export default __webpack_public_path__ + "static/media/arras20.f7fd7b93.jpg";